import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableSliderModule } from '@common/components/feature-part/table-slider/table-slider.module';
import { LanguageSelectionModalModule } from '@common/components/language-selection-modal/language-selection-modal.module';
import { GetReceiptJuniorPilotStoreModule } from '@common/store/get-receipt-junior-pilot';
import { ButtonModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';
import { AdditionalServicesModule } from '../sub-components/additional-services/additional-services.module';
import { AirportServiceModule } from '../sub-components/airport-service/airport-service.module';
import { BaggageRequestModule } from '../sub-components/baggage-request/baggage-request.module';
import { BaggageModule } from '../sub-components/baggage/baggage.module';
import { InflightMealModule } from '../sub-components/inflight-meal/inflight-meal.module';
import { JuniorPilotModule } from '../sub-components/junior-pilot/junior-pilot.module';
import { LoungeAccessModule } from '../sub-components/lounge-access/lounge-access.module';
import { LoungeServiceRequestModule } from '../sub-components/lounge-service-request/lounge-service-request.module';
import { MyBookingServicesFooterModule } from '../sub-components/my-booking-services-footer/my-booking-services-footer.module';
import { MyCarValetModule } from '../sub-components/my-car-valet/my-car-valet.module';
import { SeatReservationModule } from '../sub-components/seat-reservation/seat-reservation.module';
import { ConsiderationSupportModule } from '../sub-components/consideration-support/consideration-support.module';
import { TravelWithPetsModule } from '../sub-components/travel-with-pets/travel-with-pets.module';
import { MyBookingServicePresComponent } from './my-booking-service-pres.component';
import { MyBookingSlidebarMenuModule } from '@app/my-booking/sub-components/my-booking-slidebar-menu/my-booking-slidebar-menu.module';

@NgModule({
  declarations: [MyBookingServicePresComponent],
  imports: [
    CommonModule,
    ButtonModule,
    SeatReservationModule,
    BaggageModule,
    LoungeAccessModule,
    InflightMealModule,
    MyBookingServicesFooterModule,
    GetReceiptJuniorPilotStoreModule,
    AdditionalServicesModule,
    TravelWithPetsModule,
    MyCarValetModule,
    JuniorPilotModule,
    ConsiderationSupportModule,
    AirportServiceModule,
    TableSliderModule,
    StaticMsgModule,
    LanguageSelectionModalModule,
    BaggageRequestModule,
    LoungeServiceRequestModule,
    MyBookingSlidebarMenuModule,
  ],
  exports: [MyBookingServicePresComponent],
})
export class MyBookingServicePresModule {}
